// import router from '@/router'

// function arrayRemove(arr, value) {
//   return arr.filter(function (ele) {
//     // console.log('arr', ele.key, 'value', value.key)
//     return ele != value;
//   });
// }

// const CALENDAR_LAYOUT = [
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
//   [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
// ]

const state = {
  // NAVBAR
  isNavOpen: true,
  hideBottomNavbar: false,
  showPaymentBottomNavbar: true,
  // APP
  existSeatsIO: false,
  destroySeatsIO: false,
  isAppInstalled: false,
  // LOADING
  isLoading: false,
  // ROUTE
  isRouteLocked: false,
  // MODAL
  isMenuOpen: false,
  showSignInModal: false,
  showBuyModal: false,
  showBuyModalSeat: false,
  showPaymentModal: false,
  showTicketModal: false,
  showCitySelect: false,
  openModals: [],
  // INSTALL PROMPT
  deferredInstallPrompt: null,
  // Calendar
  // calendarLayout: CALENDAR_LAYOUT,

  typePhotos: {
    atelier: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Fatelier%2Fatelier-type_256x256.jpg?alt=media&token=cb19948c-d873-40ff-b63c-1e2d95e7abf2"
    },
    concert: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Fconcert%2Fconcert-type_256x256.jpg?alt=media&token=b8d389e6-8ad6-4ec3-ae7c-9044ddcf346e"
    },
    exhibition: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Fexhibition%2Fexhibition-type_256x256.jpg?alt=media&token=99e2e164-7a55-4abf-b5d8-bda3fa088df9"
    },
    festival: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Ffestival%2Ffestival-type_256x256.jpg?alt=media&token=48548d87-e35a-4113-996b-d4e469947ef8"
    },
    stage: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Fstage%2Fstage-type_256x256.jpg?alt=media&token=5ad1d855-a984-4aa8-a3e6-b37a811c8b68"
    },
    theatre: {
      typePhoto: "https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/type-photos%2Ftheatre%2Ftheatre-type_256x256.jpg?alt=media&token=fa745c8b-e8ed-4ade-a10d-6844b0a677cd"
    }
  },

  typeIcons: {
    concert: {
      typeIcon: "mdi-microphone-variant"
    },
    theatre: {
      typeIcon: "mdi-drama-masks"
    },
    stage: {
      typeIcon: "mdi-theater"
    },
    atelier: {
      typeIcon: "mdi-shape-plus"
    },

    festival: {
      typeIcon: "mdi-hexagon-multiple-outline"
    },
    exhibition: {
      typeIcon: "mdi-view-dashboard-outline"
    },
    // congress: {
    //   typeIcon: "mdi-theater" 
    // },
    // more: {
    //   typeIcon: "mdi-dots-horizontal" 
    // }

  }
}

const mutations = {
  // NAVBARS
  'TOGGLE_MENU': (state, p) => state.isMenuOpen = p,
  'TOGGLE_NAVBAR': (state, s) => { state.isNavOpen = s },
  'TOGGLE_CITY_SELECT': (state, s) => { state.showCitySelect = s },
  'SET_HIDE_BOTTOM_NAVBAR': (state, s) => state.hideBottomNavbar = s,
  'SET_PAYMENT_BOTTOM_NAVBAR': (state, p) => state.showPaymentBottomNavbar = p,
  'TOGGLE_MODAL_BY_NAME': (state, payload) => {
    if (payload.state) {
      state.isRouteLocked = true
      state.openModals.push(payload.name)
    } else {
      if (state.openModals.length) {
        state.openModals.pop()
        // console.log('state popped');
      }
    }

    switch (payload.name) {
      case 'BUY_MODAL':
        state.showBuyModal = payload.state
        break;
      case 'BUY_MODAL_SEAT':
        state.showBuyModalSeat = payload.state
        break;
      case 'SIGNIN_MODAL':
        state.showSignInModal = payload.state
        break;
      case 'TICKET_MODAL':
        state.showTicketModal = payload.state
        break;

      default:
        break;
    }
  },
  // LOADING
  'SET_LOADING': (state, p) => { state.isLoading = p },
  // ROUTE
  'SET_GO_BACK': (state, s) => state.isGoBack = s,
  'SET_ROUTE_LOCK': (state, p) => {
    // console.log('setting route lock to', p)
    state.isRouteLocked = p
  },
  // APP
  'SET_APP_INSTALLED': (state, s) => {
    console.log('[ui/mutations]', "set app installed:", s)
    state.isAppInstalled = s
  },
  'SET_INSTALL_PROMPT': (state, s) => {
    state.deferredInstallPrompt = s
  },
  'SET_SEATS_IO': (state, p) => state.existSeatsIO = p,
  'SET_DESTROY_SEATS_IO': (state, p) => state.destroySeatsIO = p,
  // 'SET_CLIPPED': (state, p) => state.isClipped = p
}

const actions = {
  toggleModal({ state, commit }, payload /** modal name */) {
    // console.log('actions: toggleModal, modal name', payload.name);
    commit(`TOGGLE_MODAL_BY_NAME`, { name: payload.name, state: payload.state })
  },
  closeAllModals({ commit, state }) {
    // console.log('closing all open modals :', state.openModals);
    state.openModals.forEach(modalName => {
      commit(`TOGGLE_MODAL_BY_NAME`, { name: modalName, state: false })
    })
  }
}

const getters = {
  // NAVBAR
  isMenuOpen: (state) => state.isMenuOpen,
  isNavOpen(state) { return state.isNavOpen },
  hideBottomNavbar: (state) => state.hideBottomNavbar,
  showCitySelect: (state) => state.showCitySelect,
  // MODAL
  showSignInModal: (state) => state.showSignInModal,
  showBuyModal: (state) => state.showBuyModal,
  showTicketModal: (state) => state.showTicketModal,
  showBuyModalSeat: (state) => state.showBuyModalSeat,
  showPaymentModal: (state) => state.showPaymentModal,
  // ROUTE
  isRouteLocked: (state) => state.isRouteLocked,
  // isGoBack: (state) => state.isGoBack,
  // LOADING
  isLoading: (state) => state.isLoading,
  // APP
  isAppInstalled(state) { return state.isAppInstalled },
  existSeatsIO: (state) => state.existSeatsIO,
  destroySeatsIO: (state) => state.destroySeatsIO,
  showPaymentBottomNavbar: (state) => state.showPaymentBottomNavbar,

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}